/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.content.whatsapp.rpc.WhatsAppWorkflowsUsagesRpc
 */

export const getWhatsAppWorkflowUsagesRpc = {
  serviceName: 'com.hubspot.content.whatsapp.rpc.WhatsAppWorkflowsUsagesRpc',
  rpcName: 'getWhatsAppWorkflowUsages',
  auth: 'app',
  fingerprint: 'iOKbkgBZI9p6JTU3VUP-CpTMA3qtO87a',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};